module.exports = __webpack_public_path__ + "media/src/images/balloons/womans_day_bg-86c0a75d84efb347d0d28a04e8e6a9d2.jpg";